module.exports = __webpack_public_path__ + "img/zbebarce.c22fb12d.jpg";